function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 298.43,
  y1: 374.76,
  x2: 317.58,
  y2: 696.87,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopOpacity: 0.69
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 216.12,
  y1: 344.12,
  x2: 381.68,
  y2: 568.81,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 305.15,
  y1: 422.78,
  x2: 310.41,
  y2: 557.18,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 300.88,
  y1: 451.6,
  x2: 311.02,
  y2: 700.78,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 339.66,
  y1: 160.68,
  x2: 299.11,
  y2: 331.31,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 345.43,
  y1: 165.29,
  x2: 306.01,
  y2: 331.18,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: 244.85,
  y1: 272.7,
  x2: 369.3,
  y2: 4.66,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 247.01,
  y1: 96.49,
  x2: 287.28,
  y2: 178.14,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: 182.64,
  y1: 142.44,
  x2: 255.97,
  y2: 142.44,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: 348.02,
  y1: 88.17,
  x2: 359.28,
  y2: 215.43,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: 290.92,
  y1: 274.3,
  x2: 314.57,
  y2: 459.01,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: 299.34,
  y1: 132.6,
  x2: 325.01,
  y2: 4.26,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-13",
  x1: 289.02,
  y1: 141.21,
  x2: 308.76,
  y2: -48.77,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#fff",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#fff",
  stopOpacity: 0.68
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-14",
  x1: 297.53,
  y1: 157.67,
  x2: 290.95,
  y2: 81.76,
  xlinkHref: "#linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-15",
  x1: 129.68,
  y1: 139.41,
  x2: 458.09,
  y2: 139.41,
  xlinkHref: "#linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-16",
  x1: 134.34,
  y1: 141.82,
  x2: 449.31,
  y2: 141.82,
  xlinkHref: "#linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-17",
  x1: 290.88,
  y1: 377.39,
  x2: 307.21,
  y2: 578.99,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-18",
  x1: 139.26,
  y1: -777.02,
  x2: 448.64,
  y2: -777.02,
  gradientTransform: "matrix(1, 0, 0, -1, 0, -317.43)",
  xlinkHref: "#linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-19",
  x1: 143.65,
  y1: -774.52,
  x2: 440.37,
  y2: -774.52,
  gradientTransform: "matrix(1, 0, 0, -1, 0, -317.43)",
  xlinkHref: "#linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-20",
  x1: 79.47,
  y1: 350.19,
  x2: 120.02,
  y2: 784.92,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-21",
  x1: 506.51,
  y1: 310.37,
  x2: 547.06,
  y2: 745.1,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Explosion 2");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M561.47,415.24c-8.85,33.23-25.29,63.43-52,84.83-37.58,30.11-88.09,37.19-135.95,42.42-79.66,8.69-162.13,15-238.3-9.86C112.78,525.3,91,515.21,72.33,500.72a155.6,155.6,0,0,1-28.77-29.24,46.91,46.91,0,0,1,.59-4.8c7.76-44.11,58.1-32.58,86.37-19.84,40.69,18.34,87.68,8.4,132,3.59A539.6,539.6,0,0,1,362.8,449c37.51,2.95,76.65,9.61,111.75-4,26.91-10.41,51-32.47,79.78-30.84A36.39,36.39,0,0,1,561.47,415.24Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M561.47,415.24C555.16,438.94,545,461.1,530,479.62a134.77,134.77,0,0,1-20.49,20.45c-37.58,30.11-88.09,37.19-135.95,42.42C296.91,550.85,217.69,557,144,535.33q-4.38-1.27-8.73-2.7C112.78,525.3,91,515.21,72.33,500.72a155.6,155.6,0,0,1-28.77-29.24,46.91,46.91,0,0,1,.59-4.8c7.43-42.21,53.84-33.47,82.6-21.48,1.29.54,2.55,1.09,3.77,1.64,40.69,18.34,87.68,8.4,132,3.59A539.6,539.6,0,0,1,362.8,449c37.29,2.93,76.18,9.53,111.12-3.72l.63-.24c26.91-10.41,51-32.47,79.78-30.84A36.39,36.39,0,0,1,561.47,415.24Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient)"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  points: "372.56 372.44 444.48 328.61 376.69 376.84 372.56 372.44",
  fill: "#2699fb"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M264.93,339.49s-45.71-85.92-44.54-85.92,48.88,82.81,48.88,82.81Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  points: "327.08 308.74 376.69 255.37 331.11 313.03 327.08 308.74",
  fill: "#2699fb"
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  points: "163.22 245.24 244.24 333.68 239.95 347.17 163.22 245.24",
  fill: "#2699fb"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M300.32,324.89c-.46-3.11,0-114.17,0-114.17L310.4,324.26Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref11 = /*#__PURE__*/React.createElement("polygon", {
  points: "354.1 354.71 476.04 280.69 354.1 362.12 354.1 354.71",
  fill: "#2699fb"
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  points: "210.22 379.13 119.96 327.05 208.92 394.02 210.22 379.13",
  fill: "#2699fb"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M422.58,503.1l-16.65,8.18L323.53,513H191.47s-9.07-5.89-15.49-20.47c0,0-8.18-8.27-3.5-17.85,4.47-9.2,12.17-.77,12.81,0-.55-.79-8.36-12.27-7.11-37.89.51-10.34,2.9-18.3,6.4-23,5.44-7.35,13.56-6.78,21.38,5-.77-1.24-5.24-9,.12-16.77,5.16-7.5,11.72.12,13.18,1.95-1.24-2-6.52-11.18-2.37-17.14,4.67-6.72,10.81,1.46,10.81,1.46a74.62,74.62,0,0,1,0-14.49c1.11-9.46,5.26-17.81,18.74-4.5,0,0,12.27-54.93,63.69-52.6s48.51,47.69,48.51,47.69,3-4.42,8.25-1a11.52,11.52,0,0,1,1.39,1c6.12,5.19,4.38,27,0,34.67.49-.66,7.8-10.42,15.51-12.08a8.79,8.79,0,0,1,7.55,1.6c9.57,7.32.7,32.82,0,34.67l0,.1a.39.39,0,0,0,.09-.07,10.92,10.92,0,0,1,1.79-.9c2.82-1.11,8.43-2.16,14.19,3.6,8.18,8.18,3.8,18.12,3.8,18.12a8.45,8.45,0,0,1,4.5-2.56,11.63,11.63,0,0,1,6.51.52,27.9,27.9,0,0,1,9.53,6.25l.5.46C446.25,462.19,449.17,490,422.58,503.1Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M421.59,502.52a6.22,6.22,0,0,1-.83,1.19c-3.17,3.52-10.55,5.46-14.83,7.57L323.53,513c-42.52,0-85.56,2.1-128,0-10-.49-17.76-8.22-21.58-17.62-2.84-7-1.53-16.35,4.95-20.26,2.34-1.4,5.39-2.27,6.39-4.8.67-1.7.17-3.6-.32-5.36a188.5,188.5,0,0,1-6.65-41.4c-.13-2.76-.19-5.61.82-8.19,2.14-5.43,8.46-8.07,14.29-8.37s11.62,1.16,17.46,1.18a6.09,6.09,0,0,0,2.9-.52,6.19,6.19,0,0,0,2.44-3.33c1.84-4.58,2.8-9.5,5.08-13.87s6.37-8.29,11.29-8.42a21.26,21.26,0,0,1,13-19.85c.72-12.94,5.12-26.1,14.32-35.23s23.71-13.42,35.72-8.54c3.53,1.43,6.86,3.6,10.64,4,4,.43,7.9-1.16,11.71-2.44,7.46-2.5,15.47-3.85,23.23-2.54s15.24,5.56,19.28,12.31c8.2,13.68.17,31.35,2.81,47.07a7.56,7.56,0,0,0,1.64,4.05c1.86,1.94,5,1.66,7.54,2.44,6.61,2,8.43,10.5,8.19,17.41s-1,14.77,3.71,19.8c2.66-7.34,13.55-10,19.26-4.62,6,5.65,4.64,15.29,5.3,23.54a6,6,0,0,0,1,3.36c2.4,2.94,6.9-.08,10.6-.92,4.64-1.05,9.43,2.06,11.77,6.19s2.78,9.05,3,13.8c.33,7.47.16,15.29-3.27,21.93-1.79,3.46-4.43,6.28-6.5,9.54C424,495.71,423,500,421.59,502.52Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M421.59,502.52a6.22,6.22,0,0,1-.83,1.19c-3.17,3.52-10.55,5.46-14.83,7.57L323.53,513c-42.52,0-85.56,2.1-128,0-10-.49-17.76-8.22-21.58-17.62-2.84-7-1.53-16.35,4.95-20.26,2.34-1.4,5.39-2.27,6.39-4.8.67-1.7.17-3.6-.32-5.36a188.5,188.5,0,0,1-6.65-41.4c-.13-2.76-.19-5.61.82-8.19,2.14-5.43,8.46-8.07,14.29-8.37s11.62,1.16,17.46,1.18a6.09,6.09,0,0,0,2.9-.52,6.19,6.19,0,0,0,2.44-3.33c1.84-4.58,2.8-9.5,5.08-13.87s6.37-8.29,11.29-8.42a21.26,21.26,0,0,1,13-19.85c.72-12.94,5.12-26.1,14.32-35.23s23.71-13.42,35.72-8.54c3.53,1.43,6.86,3.6,10.64,4,4,.43,7.9-1.16,11.71-2.44,7.46-2.5,15.47-3.85,23.23-2.54s15.24,5.56,19.28,12.31c8.2,13.68.17,31.35,2.81,47.07a7.56,7.56,0,0,0,1.64,4.05c1.86,1.94,5,1.66,7.54,2.44,6.61,2,8.43,10.5,8.19,17.41s-1,14.77,3.71,19.8c2.66-7.34,13.55-10,19.26-4.62,6,5.65,4.64,15.29,5.3,23.54a6,6,0,0,0,1,3.36c2.4,2.94,6.9-.08,10.6-.92,4.64-1.05,9.43,2.06,11.77,6.19s2.78,9.05,3,13.8c.33,7.47.16,15.29-3.27,21.93-1.79,3.46-4.43,6.28-6.5,9.54C424,495.71,423,500,421.59,502.52Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-2)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M264,298.68s2-13.7-3-12.17S264,298.68,264,298.68Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M388.77,340.32s4.46-16.71,9.7-12.75S388.77,340.32,388.77,340.32Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M171.37,351.24s-5.74-14.91-10.9-9.75S171.37,351.24,171.37,351.24Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M204.66,443.37c0-.17.09-.35.15-.53,1.49-4.89,6-8.28,10.57-10.53s9.46-3.64,14.42-3.16c6.76.64,12.86,4.91,16.7,10.51s5.63,12.41,6.17,19.19a20.93,20.93,0,0,1,21.22-17.78,15.25,15.25,0,0,1,5.29.76c1.4.58,2.22,1.47,3.92,1a10.12,10.12,0,0,0,2.8-1.59,34.43,34.43,0,0,1,7.89-4.53,13.19,13.19,0,0,1,8.93-.33,31.16,31.16,0,0,0-20,20.66,34.7,34.7,0,0,1,1.59-11,16.67,16.67,0,0,0-12.71,4.61c-9.39,9.12-3.61,26.39,7.79,30.92,2.79,1.11,6.64,1.66,9.51.49,4-1.64,6.94-7,7.9-11-4.36,2-9.37,2-14.18,1.88a59.93,59.93,0,0,0,32.27-22.1,57.92,57.92,0,0,1-4.14,9.6,19.12,19.12,0,0,1-7.24,7.39,1.32,1.32,0,0,0-.71.62,1.27,1.27,0,0,0,.1.89c3,8.2,8.05,23.55,19.6,21.18,9.5-2,12-13.26,10.89-21.58,1,.79,2.89-.74,3.93-1.25-4.62-3-9-7.62-8.76-13.13a40.2,40.2,0,0,0,20.82,11.89,26.14,26.14,0,0,1-9.34,1.11,38.25,38.25,0,0,0,11.22,12.29c4.53,3.26,12,2.48,17.13,1,5.9-1.72,11.07-2.94,15.11-8a48,48,0,0,0,5.77-10.22c2.64-5.8,5.14-12.2,3.62-18.39-1.26-5.1-5.05-9.13-8.69-12.91a24.92,24.92,0,0,1-4.5,19.38c1.62-3.68,1.74-7.85,1.58-11.87a22.09,22.09,0,0,0-1.57-8.42c-.63-1.38-4.83-4.37-4.14-5.79,1-2.14,6.91,1.1,8.19,2a18.88,18.88,0,0,0-.92-12.14c3.38,2.92,6.27,6.77,6.73,11.22a9.08,9.08,0,0,0,.51,2.94,7.23,7.23,0,0,0,1.64,2,30.37,30.37,0,0,1,7.5,12.11,26.47,26.47,0,0,0,3-19.51c2.22,5.72,3.66,12.08,2,18a42.54,42.54,0,0,1-3.34,7.54,121.15,121.15,0,0,0-8,20c-.65,2.2-2.71,6.11.91,5.14a21,21,0,0,0,3.54-1.54c6.92-3.38,13-8.7,16.24-15.8a28.83,28.83,0,0,0,2.14-6.95c.12-.72.56-8.06.41-8,3.49-.8,9,0,16.54,7.23,14,13.44,16.95,41.2-9.64,54.35l-16.65,8.18L323.92,513H191.85s-9.07-5.89-15.48-20.47c0,0-8.18-8.27-3.51-17.85,4.48-9.2,12.18-.77,12.81,0-.55-.79-8.35-12.27-7.1-37.89.51-10.34,2.89-18.3,6.4-23-.4,12.17-.25,28.22,6.19,39,3.3,5.53,8.79,10.66,14,14.38a53,53,0,0,0,9,5.14c2.63,1.18,6.85,1.54,9.12,3.09A49.05,49.05,0,0,1,207,456.62c-1.7-3.44-3-7.29-2.71-11.18.33-4.05,2.9-8.05,4.35-11.82.16-.42.31-1,0-1.29a1.17,1.17,0,0,0-1.07-.17,11.34,11.34,0,0,0-7,5,21.49,21.49,0,0,0-3,8.24c-.16-4.53-.25-9.32,2-13.27,2.1-3.73,6-6.11,9.81-8,11.27-5.43,24.47-7.75,36.43-4.09-8.82-.42-17.88-.8-26.24,2a10.75,10.75,0,0,0-5.17,3.15c-1.26,1.61-1.59,4.12-.23,5.65,1,1.16,2.65,1.5,4.17,1.77",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-3)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M462.47,507.09c-2.26,4.05-6.81,6.87-11.48,7.81-6,1.21-12.15,0-18.13-1.24-1.46,8-11.55,10.68-19.69,10.78a113.87,113.87,0,0,1-24.5-2.33,8.78,8.78,0,0,0-4.25-.19c-1.95.59-3.17,2.46-4.46,4-6.07,7.44-16.23,10-25.78,11.07a120.6,120.6,0,0,1-48.53-4.76c-3.95-1.23-8-2.69-12.1-2.37a31.71,31.71,0,0,0-7.21,1.79,150.88,150.88,0,0,1-91.66.11c-4.83-1.54-10.62-5.15-9.34-10.06a154.51,154.51,0,0,1-28-1.09c-12.64-1.65-17.65-8.2-14-20.33a13.33,13.33,0,0,1,8.6-9.4c11.69-4,19.28,11.36,18.7,9.69s-5.2-16.37,0-18.71c5.08-2.28,9.9,17.49,10.18,18.65,0-.87-.59-10.64,5.27-11,6.14-.33,9.94,12,9.94,12s0-13.37,4.38-12,5.84,14,5.84,14,3.51-14,6.72-11.36,3.22,10.7,3.22,10.7,17-35.42,30.39-29.41c10.07,4.5,9.47,18.42,8.54,25.1.55-2,1.51-4,3.14-4.37,3.22-.68,3.51,8.68,3.51,8.68s.29-11.39,6.43-11.37c5.75,0,8.24,8.23,8.53,9.25-.18-.85-1.22-6.67,2.57-7.91,4.09-1.33,5.84,10.69,6.14,9.69s-.59-17,9.64-21.05c9.77-3.83,14.2,15.8,14.58,17.58-.34-2.1-4.4-28.53,8.5-34.62,13.44-6.34,7.6,31.08,7.6,31.08s5-9.75,10.52-8.56c3.67.8,1.34,7.47-.66,11.92,2.38-4.43,6.51-10.82,10-9.71s3.77,8.05,3.51,12.2c.63-3.85,2.6-10,8.66-11.2,8.69-1.73,14.45,12.9,14.79,13.77-.15-.75-2.37-12,7.42-12.43,8.55-.37,11.83,10.38,12.64,13.73.11.46.18.77.2.9,0-.13-.06-.43-.1-.87-.35-3.58-.76-16.25,10.24-20.45,12.85-4.89,15.19,5.8,15.19,5.8s4.21-24.68,23.28-19c9.63,2.89,24.09,21.34,22.35,31.65A11.5,11.5,0,0,1,462.47,507.09Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M462.47,507.09c-2.26,4.05-6.81,6.87-11.48,7.81-6,1.21-12.15,0-18.13-1.24-1.46,8-11.55,10.68-19.69,10.78a113.87,113.87,0,0,1-24.5-2.33,8.78,8.78,0,0,0-4.25-.19c-1.95.59-3.17,2.46-4.46,4-6.07,7.44-16.23,10-25.78,11.07a120.6,120.6,0,0,1-48.53-4.76c-3.95-1.23-8-2.69-12.1-2.37a31.71,31.71,0,0,0-7.21,1.79,150.88,150.88,0,0,1-91.66.11c-4.83-1.54-10.62-5.15-9.34-10.06a154.51,154.51,0,0,1-28-1.09c-12.64-1.65-17.65-8.2-14-20.33a13.33,13.33,0,0,1,8.6-9.4c11.69-4,19.28,11.36,18.7,9.69s-5.2-16.37,0-18.71c5.08-2.28,9.9,17.49,10.18,18.65,0-.87-.59-10.64,5.27-11,6.14-.33,9.94,12,9.94,12s0-13.37,4.38-12,5.84,14,5.84,14,3.51-14,6.72-11.36,3.22,10.7,3.22,10.7,17-35.42,30.39-29.41c10.07,4.5,9.47,18.42,8.54,25.1.55-2,1.51-4,3.14-4.37,3.22-.68,3.51,8.68,3.51,8.68s.29-11.39,6.43-11.37c5.75,0,8.24,8.23,8.53,9.25-.18-.85-1.22-6.67,2.57-7.91,4.09-1.33,5.84,10.69,6.14,9.69s-.59-17,9.64-21.05c9.77-3.83,14.2,15.8,14.58,17.58-.34-2.1-4.4-28.53,8.5-34.62,13.44-6.34,7.6,31.08,7.6,31.08s5-9.75,10.52-8.56c3.67.8,1.34,7.47-.66,11.92,2.38-4.43,6.51-10.82,10-9.71s3.77,8.05,3.51,12.2c.63-3.85,2.6-10,8.66-11.2,8.69-1.73,14.45,12.9,14.79,13.77-.15-.75-2.37-12,7.42-12.43,8.55-.37,11.83,10.38,12.64,13.73.11.46.18.77.2.9,0-.13-.06-.43-.1-.87-.35-3.58-.76-16.25,10.24-20.45,12.85-4.89,15.19,5.8,15.19,5.8s4.21-24.68,23.28-19c9.63,2.89,24.09,21.34,22.35,31.65A11.5,11.5,0,0,1,462.47,507.09Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-4)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M312.72,438.3s16,14,41.29-2.79c0,0-16.52,17.92-31.44,16S312.72,438.3,312.72,438.3Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb",
  opacity: 0.5
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M354,456.54s10.61,4.29,19.14-1.55,4.63-9.75,4.63-9.75,8,10.52-.28,14.81S354,456.54,354,456.54Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb",
  opacity: 0.5
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M209.09,418s-1.46-6.23,4.53-7.79,10.5,14,10.5,14-1.25-16.61-10.5-17.79S209.09,418,209.09,418Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb",
  opacity: 0.5
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M193.9,473.69s8.24,15.48,30.22,12.41c0,0-13,5.7-22,3.07S193.9,473.69,193.9,473.69Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb",
  opacity: 0.5
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M369.23,487.71s13.46,3.32,20.52-5.94a12.75,12.75,0,0,1-8.49,10.35C373.49,494.72,369.23,487.71,369.23,487.71Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb",
  opacity: 0.5
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M430.76,456.25c-3.5,9.83-14.42,12.61-14.42,12.61,11.44-10,8.66-20.7,5.86-26.82a27.9,27.9,0,0,1,9.53,6.25A17.93,17.93,0,0,1,430.76,456.25Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb",
  opacity: 0.5
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M216,368c-1.07-6.87-3-27.5-12.89-27.57-9.24-.06,0,7.49,6.44,17.53Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M363.1,343s5.73-28.82,14.54-27.07,5.95,6.75,0,12.91C370.47,336.24,363.1,343,363.1,343Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M314.86,301.49s-3.5-26.1,3.8-25.32S314.86,301.49,314.86,301.49Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M331.91,366.33c-1.49,11.2-8.21,16.43-27.61,17.4s-24.63-25-24.63-25-4.48-11.05,0-16.65a4.62,4.62,0,0,1,.87-.85c3.58-2.64,8,4,9.57,6.61.25.41.43.73.51.87-.06-.14-.19-.47-.37-.95A41.48,41.48,0,0,1,288,339c-.49-3.88-.14-7.87,2.71-9.74,6.52-4.25,9.6,5.76,9.6,5.76.4-5,.51-11.94.4-20.13-.45-33.42-4.55-87.54-6.69-114.17-.8-9.75-1.34-15.82-1.34-15.82l8.11-9,13,14.34s.35,1.29-.57,14.05c-.66,9-1.94,23.71-4.42,47.72-6,58,4.8,92.36,4.8,92.36s1.63-6.69,7.78-3.28a13.77,13.77,0,0,1,1.59,1c6.35,4.76,1.38,16.79-.27,20.3C328.45,350.91,333.36,355.44,331.91,366.33Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M331.91,366.34c-1,7.77-4.58,12.66-13.12,15.25a61.18,61.18,0,0,1-14.49,2.15c-19.41,1-24.63-25-24.63-25s-4.48-11.05,0-16.65a3.89,3.89,0,0,1,.88-.85c1.7-1.26,3.61-.4,5.3,1.11a25.07,25.07,0,0,1,4.27,5.49l.5.88c-.05-.15-.19-.47-.37-1a43.3,43.3,0,0,1-2.21-8.21c0-.19-.06-.39-.08-.58-.5-3.89-.15-7.87,2.71-9.74,2.38-1.56,4.31-1.21,5.79-.13,2.57,1.86,3.8,5.88,3.8,5.88.19-2.36.31-5.15.38-8.3.08-3.52.08-7.5,0-11.83-.44-33.42-4.54-87.54-6.69-114.16-.8-9.75-1.33-15.82-1.33-15.82l8.1-9,3,3.26,10.07,11.09s.35,1.28-.57,14.05c-.66,9-1.93,23.71-4.42,47.71-6,58,4.8,92.37,4.8,92.37s1.42-5.81,6.58-3.85a8.61,8.61,0,0,1,1.21.57l.14.08a11.24,11.24,0,0,1,1.44,1c6.35,4.76,1.38,16.78-.26,20.3,3.71-7.39,7.07-8.15,8.61-4.83a5.15,5.15,0,0,1,.2.52A18.22,18.22,0,0,1,331.91,366.34Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-5)"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M339.14,364.84c-1.29,9.66-6.47,14.88-20.35,16.75-2.2.3-4.61.52-7.26.65-19.41,1-24.63-25-24.63-25s-3.66-9-1-14.89a7.66,7.66,0,0,1,1-1.76,4.08,4.08,0,0,1,.87-.85l.27-.18c3.54-2.14,7.81,4.27,9.3,6.78.25.42.43.73.51.88-.06-.15-.19-.48-.37-1a41.48,41.48,0,0,1-2.3-8.79c-.39-3.1-.25-6.26,1.28-8.36a5.38,5.38,0,0,1,1.43-1.38,6.16,6.16,0,0,1,2.75-1c4.64-.39,6.85,6.8,6.85,6.8.4-5-3.82-18.1-3.94-26.29-.44-33.42-.2-81.38-2.35-108-.8-9.75-1.34-15.82-1.34-15.82l3.84-4.27,10.07,11.09s.35,1.28-.57,14.05c-.66,9-1.93,23.71-4.42,47.71-6,58,4.8,92.37,4.8,92.37s1.42-5.81,6.58-3.85c.4,1.55.65,2.35.65,2.35a7.24,7.24,0,0,1,.7-1.7c1-1.72,3.06-3.82,7.08-1.58a11.55,11.55,0,0,1,1.59,1c5,3.73,3,11.92,1.12,17-.52,1.4-1,2.56-1.39,3.32a29.74,29.74,0,0,1,1.59-2.8C336.54,350.31,340.45,355,339.14,364.84Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-6)"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M331.91,366.33c-1.49,11.2-8.21,16.43-27.61,17.4s-24.63-25-24.63-25-4.48-11.05,0-16.65a4.62,4.62,0,0,1,.87-.85c3.58,1,6.63,4.8,8.42,11.24-.27-1.51-.32-3.66,1.15-4.63l.14-.08a5,5,0,0,1,3.64-.22c7.42,1.63,8.14,23.73,8.14,23.73s1.52-13.43,8.24-15.15,9.94,8,9.94,8-1.51-14.72,1.15-23.1a13.77,13.77,0,0,1,1.59,1c6.35,4.76,1.38,16.79-.27,20.3C328.45,350.91,333.36,355.44,331.91,366.33Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M426.58,161.28a31.83,31.83,0,0,1-5.11,12.5,32.6,32.6,0,0,1-7.7,8.13c-20.41,15.18-54.24,3.43-54.24,3.43s-5.23,11.87-26.13,14.33c-17.65,2.09-28.79-16.34-31.82-22.12-.56-1.06-.84-1.7-.84-1.7s-.38.63-1.12,1.62c-4.73,6.43-24.08,28.43-50.56.37,0,0-20.9,22.06-53,7.5-9.23-4.18-14.93-9.4-18.28-15a30.19,30.19,0,0,1-4.26-16.46c.12-8.31,3-15.79,4.61-20,0,0,0,0,0,0a14.33,14.33,0,0,1,3.19-4.83c22.6-8.33,63.92-16,123.6-13.91,16.31.57,30.91,1.56,43.92,2.84,2.6.26,5.15.53,7.63.81q12.34,1.41,22.64,3.17h0c7.37,1.24,14,2.6,19.86,4a166.68,166.68,0,0,1,17.5,5.21,49.43,49.43,0,0,1,8.42,14.1A30.69,30.69,0,0,1,426.58,161.28Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M426.58,161.28a31.83,31.83,0,0,1-5.11,12.5,32.6,32.6,0,0,1-7.7,8.13c-20.41,15.18-54.24,3.43-54.24,3.43s-5.23,11.87-26.13,14.33c-17.65,2.09-28.79-16.34-31.82-22.12-.56-1.06-.84-1.7-.84-1.7s-.38.63-1.12,1.62c-4.73,6.43-24.08,28.43-50.56.37,0,0-20.9,22.06-53,7.5-9.23-4.18-14.93-9.4-18.28-15a30.19,30.19,0,0,1-4.26-16.46c.12-8.31,3-15.79,4.61-20,0,0,0,0,0,0a14.33,14.33,0,0,1,3.19-4.83c22.6-8.33,63.92-16,123.6-13.91,16.31.57,30.91,1.56,43.92,2.84,2.6.26,5.15.53,7.63.81q12.34,1.41,22.64,3.17h0c7.37,1.24,14,2.6,19.86,4a166.68,166.68,0,0,1,17.5,5.21,49.43,49.43,0,0,1,8.42,14.1A30.69,30.69,0,0,1,426.58,161.28Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-7)"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M284.35,149.27a44.16,44.16,0,0,1-28.3-14.41c-5-5.65-8.66-13.17-7.54-20.66a4.64,4.64,0,0,1,.89-2.37c.88-1,2.36-1.19,3.69-1.31,4-.33,10.22-2.42,12.79,1.51,2.05,3.14,1.39,9.19,2.33,12.81a45.66,45.66,0,0,0,6,13.57C275.89,140.93,281,148.93,284.35,149.27Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-8)"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M191.45,149.57a62.06,62.06,0,0,0,15.2,18.59c-8.86.44-17.13-5.83-20.92-13.85s-3.71-17.39-1.85-26.06a4.78,4.78,0,0,1,1-2.44,5.08,5.08,0,0,1,2.63-1.16q12.15-2.72,24.36-5.14c4.81-1,9.92-3.57,14.93-2.6a5.83,5.83,0,0,1,2.91,1.37c1.37,1.23,1,2.86,1.16,4.59a86.24,86.24,0,0,0,1.79,12.48c1.87-4.42,5.79-7.63,9.84-10.2,3.35-2.13,7.19-4,11.13-3.5a11,11,0,0,0-6.14,13.27c1.41,4.22,5.22,7.08,8.45,10.15-1.62-.18-3.23-.43-4.83-.74a11.71,11.71,0,0,1-4.48-1.62,13,13,0,0,1-3.3-4,23.4,23.4,0,0,1-3.33-7c-1.91,1.19-4.24,2.58-5.4,4.6s.64,4,1.74,5.74a31.83,31.83,0,0,0,4.36,5.59c.77.78,4.17,4.5,5.31,4.27-6.27,1.27-12.91-1.42-17.48-5.9s-7.29-10.55-8.94-16.73a124.7,124.7,0,0,0-25.43,10.44c-1.58.87-3.25,1.88-3.91,3.55-1.09,2.73.32,6.3,3.16,6.87,3.14.64,6.38,0,9.54.16a3.92,3.92,0,0,1,1.56.32A4.71,4.71,0,0,1,206,152a22.86,22.86,0,0,0,14,7.72,22.84,22.84,0,0,1-5.35-10.14,15.56,15.56,0,0,1,1.67-11.19,16.13,16.13,0,0,0-6.63,9.16L198,144.67a5.38,5.38,0,0,1-2.33-1c-1.47-1.28-1.12-3.62-.65-5.51",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-9)"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M398.74,152.23a21.25,21.25,0,0,0,10.42-6.61c-7.09,15.12-23.9,25.1-40.57,24.09a32.77,32.77,0,0,0,20.16-15.88c-3.76.76-7.59,1.52-11.42,1.24s-7.74-1.73-10.17-4.71c4.42,1.33,9.4-.07,13-3a22.91,22.91,0,0,0,7.14-11.63,3.33,3.33,0,0,0,0-2.52,3.39,3.39,0,0,0-1.51-1.2,95,95,0,0,0-18.49-7.15,2.46,2.46,0,0,0-1.81,0,2.74,2.74,0,0,0-1,1.76c-1.84,5.82-7.64,9.74-13.64,10.84s-12.18-.21-18-2a13.43,13.43,0,0,1-6.8,15.72c5.8,5.46,14.71,5.42,22.67,5A26.11,26.11,0,0,1,328.29,160a14.93,14.93,0,0,0,11,15.1A20.68,20.68,0,0,1,352.7,164.5a11,11,0,0,0-1.63,20,7.47,7.47,0,0,1-8.18-2.83,6.8,6.8,0,0,0-1.27-1.63,5.54,5.54,0,0,0-3.17-.61c-4.95-.15-9.43-3.29-12.41-7.24s-4.71-8.7-6.4-13.36l-7.6,9.47c2.87-4.83,1.95-11.42,5.47-15.8a36.15,36.15,0,0,1,4.12-3.79,20.77,20.77,0,0,0,6.47-18.13c-1.85,4-6.86,5.3-11.26,5.49a44.91,44.91,0,0,1-21-4.24,50.76,50.76,0,0,0,21.28-.88,22,22,0,0,0,9.22-4.4c2.57-2.29,4.28-5.77,3.72-9.16,12.45-1,25-2,37.41-1,11.7.95,25.15,3.73,35.31,10C411.7,131.87,405,147.13,398.74,152.23Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-10)"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M390,394.66a11.3,11.3,0,0,1-7.66,7.37s-7,5.36-24.57-5.83h0c0,.1,0,.21,0,.31a2.23,2.23,0,0,1,0,.23s0,.07,0,.1a2.5,2.5,0,0,1-.05.29c-.7,3.62-4.27,16.44-19.66,16.44a48.29,48.29,0,0,1-23.83-6.3,34.09,34.09,0,0,1-5.28-3.6s-1.67,9.9-16.15,9.9c-14.15,0-10.87-9.48-10.73-9.89-.78.62-29.33,23.12-57.47-8.54-5.19-5.84-7.12-15.66-1.76-19.6a7.85,7.85,0,0,1,1.76-1c7.47-3,16.42,9.18,16.42,9.18s-2.24-5.65,5.23-9.65c5.64-3,7.45,3.36,8,6.65-.49-4.79-1.08-17.87,6.18-22,7.47-4.23,14.59,5.42,16.76,8.76-1.74-3-5.87-11.5,1.31-13.22s11,12,12,16.77c-.34-2.61-.11-7.49,6.48-6.94,9,.75,3.42,19.63,5.44,19.63s1.57-17.53,11.5-20.37c8.6-2.48,13,8.83,14.05,11.91-.95-3.28-3.88-16,7.83-15.84,13.43.19,22.05,16.61,22.05,16.61a25.45,25.45,0,0,1,.38-6.36c1.09-5.47,4.73-11.64,16.37-5.58a31.75,31.75,0,0,1,6.76,4.7c6,5.43,9.24,12.57,9.63,18.9A17.16,17.16,0,0,1,390,394.66Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M390,394.66a11.3,11.3,0,0,1-7.66,7.37s-7,5.36-24.57-5.83h0c0,.1,0,.21,0,.31a2.23,2.23,0,0,1,0,.23s0,.07,0,.1a2.5,2.5,0,0,1-.05.29c-.7,3.62-4.27,16.44-19.66,16.44a48.29,48.29,0,0,1-23.83-6.3,34.09,34.09,0,0,1-5.28-3.6s-1.67,9.9-16.15,9.9c-14.15,0-10.87-9.48-10.73-9.89-.78.62-29.33,23.12-57.47-8.54-5.19-5.84-7.12-15.66-1.76-19.6a7.85,7.85,0,0,1,1.76-1c7.47-3,16.42,9.18,16.42,9.18s-2.24-5.65,5.23-9.65c5.64-3,7.45,3.36,8,6.65-.49-4.79-1.08-17.87,6.18-22,7.47-4.23,14.59,5.42,16.76,8.76-1.74-3-5.87-11.5,1.31-13.22s11,12,12,16.77c-.34-2.61-.11-7.49,6.48-6.94,9,.75,3.42,19.63,5.44,19.63s1.57-17.53,11.5-20.37c8.6-2.48,13,8.83,14.05,11.91-.95-3.28-3.88-16,7.83-15.84,13.43.19,22.05,16.61,22.05,16.61a25.45,25.45,0,0,1,.38-6.36c1.09-5.47,4.73-11.64,16.37-5.58a31.75,31.75,0,0,1,6.76,4.7c6,5.43,9.24,12.57,9.63,18.9A17.16,17.16,0,0,1,390,394.66Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-11)"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M410.32,110.12c-4.06-1.31-8.33-2.56-12.77-3.75-24.31-6.48-54.25-11-88.77-11.85-41.08-1-79.66,4.07-110.72,12,2.85-12.67,9.72-30.1,26.37-40.24,27.62-16.83,50,0,50,0s25.37-28.47,64.18-16.85,45.54,49.69,45.54,49.69a37,37,0,0,1,12.77-.2c4.2.76,8.47,2.58,11.11,6.55A18.65,18.65,0,0,1,410.32,110.12Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M410.32,110.12c-4.06-1.31-8.33-2.56-12.77-3.75-24.31-6.48-54.25-11-88.77-11.85-41.08-1-79.66,4.07-110.72,12,2.85-12.67,9.72-30.1,26.37-40.24,27.62-16.83,50,0,50,0s25.37-28.47,64.18-16.85,45.54,49.69,45.54,49.69a37,37,0,0,1,12.77-.2c4.2.76,8.47,2.58,11.11,6.55A18.65,18.65,0,0,1,410.32,110.12Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-12)"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M274.44,82.71s-29.12-16.41-50,3c0,0,2.94-19.21,19.41-22.4S274.44,75,274.44,75,294.65,50.31,323,52.49s42.54,23.13,42.54,29.29c0,8.83-11.47,22.39-26.31,11.76-10.15-7.28,1.28-21.28,1.28-21.28s2.75-8.34-23.48-9.7S274.44,82.71,274.44,82.71Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-13)"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M220.64,105.48c-3.12,1.9,12-23.51,30.66-19.78s26.37,21.23,26.37,21.23S251.93,86.45,220.64,105.48Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M396.93,98.94c4.2.76,8.47,2.58,11.11,6.55a18.65,18.65,0,0,1,2.28,4.63c-4.06-1.31-8.33-2.56-12.77-3.75A28.55,28.55,0,0,0,396.93,98.94Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M467.76,151.57c-.38,11.09-13.87,18.68-27.28,23.5a163.08,163.08,0,0,1-26.71,6.84,31.91,31.91,0,0,0,3.75-3.28h0a25.28,25.28,0,0,0,1.82-2c.45-.53.89-1.08,1.31-1.66.28-.38.54-.76.81-1.16h0a31.92,31.92,0,0,0,5.1-12.49l0,0s15-1.66,12.79-13.6c-.94-5-8-11-22.9-16.4-20.6-7.53-56.22-14.11-111.56-16.07-59.68-2.1-101,5.58-123.6,13.91-13.53,5-20.34,10.22-20.34,13.71,0,9.33,12.53,11.13,12.54,11.13a30.19,30.19,0,0,0,4.26,16.46v0s-19.34.69-34.4-4.21c-.61-.2-1.23-.41-1.82-.63a42,42,0,0,1-4.1-1.73,29.33,29.33,0,0,1-3.69-2.12c-4.71-3.17-7.83-7.48-7.83-13.33,0-13.94,28.67-30.74,72.11-41.86,31.06-8,69.64-13,110.72-12,40.85,1,75.28,7.15,101.54,15.6C447.39,122.06,468.19,138.57,467.76,151.57Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M457.1,162a16.22,16.22,0,0,1-4.26,6.3,20.22,20.22,0,0,1-5.93,3.75c-1,.39-1.93.78-2.88,1.18l-2.92,1c-1.92.6-3.75,1.18-5.56,1.59-3.59.89-6.92,1.46-9.93,1.9s-5.73.72-8.09.92a25.28,25.28,0,0,0,1.82-2c1.8-.26,3.78-.58,5.91-1a98.64,98.64,0,0,0,9.61-2.32c1.73-.48,3.5-1.08,5.31-1.71l2.71-1,2.84-1.26a14.71,14.71,0,0,0,8.17-8.43,14,14,0,0,0,.48-6.36,21.16,21.16,0,0,0-2.23-6.56,39.61,39.61,0,0,0-9.9-11.65,79.33,79.33,0,0,0-14.05-9.22c-2.55-1.37-5.25-2.61-8-3.8-1.35-.6-2.81-1.15-4.23-1.74s-2.84-1-4.28-1.55l-4.35-1.55-4.5-1.34-4.54-1.33-4.65-1.13a309.22,309.22,0,0,0-39.06-6.54c-13.45-1.43-27.19-2.37-40.95-2.92s-27.55-.77-41.14-1l-10.16-.14c-3.35,0-6.64,0-9.94.14-6.58.34-13.09.9-19.44,1.86a266.66,266.66,0,0,0-36.21,7.88,278.39,278.39,0,0,0-31.38,11c-4.71,2-9.23,4.07-13.34,6.24-1,.54-2.06,1-3.06,1.61l-2.94,1.71a56.8,56.8,0,0,0-5.32,3.49c-3.28,2.43-6.08,5.13-7.63,8.14a11.27,11.27,0,0,0-.79,8.9,24.41,24.41,0,0,0,3.65,6.82c.52.7,1,1.35,1.49,2a29.33,29.33,0,0,1-3.69-2.12c-.46-.62-.91-1.3-1.36-2a21,21,0,0,1-1.94-4,14,14,0,0,1-.79-5.06,13.6,13.6,0,0,1,1.43-5.46c1.76-3.52,4.77-6.46,8.16-9.08a56.32,56.32,0,0,1,5.5-3.74l2.92-1.73c1-.59,2.06-1.12,3.12-1.69,4.22-2.3,8.73-4.38,13.5-6.51a285.78,285.78,0,0,1,31.57-11.49,273.11,273.11,0,0,1,36.6-8.36c6.44-1,13-1.68,19.77-2.1,3.36-.14,6.77-.22,10.15-.25l10.16,0c13.6,0,27.43.19,41.27.67s27.68,1.28,41.26,2.78a311.55,311.55,0,0,1,39.64,6.65c1.59.39,3.17.77,4.73,1.17s3.12.9,4.66,1.36l4.61,1.37,4.49,1.6c1.49.55,2.95,1,4.46,1.62s2.83,1.15,4.24,1.79c2.87,1.28,5.63,2.59,8.29,4a80.26,80.26,0,0,1,14.7,9.89,43.38,43.38,0,0,1,10.63,13A23.41,23.41,0,0,1,458,154,17.49,17.49,0,0,1,457.1,162Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M449.13,156.13a14.54,14.54,0,0,1-2.85,6.36A22,22,0,0,1,441.6,167a40.66,40.66,0,0,1-10.26,5.23,65.13,65.13,0,0,1-9.41,2.51l-1.27.23c.28-.38.54-.76.81-1.16h0l.25-.06a63,63,0,0,0,9.17-2.7,40.76,40.76,0,0,0,9.84-5.21,21.05,21.05,0,0,0,4.3-4.24,12.81,12.81,0,0,0,2.45-5.69,12.65,12.65,0,0,0-.76-6.45,22.79,22.79,0,0,0-3.56-6,35.15,35.15,0,0,0-2.44-2.76c-.42-.44-.86-.89-1.34-1.34s-.91-.83-1.39-1.26a42.32,42.32,0,0,0-6.38-4.39A88.38,88.38,0,0,0,416.54,127a241.21,241.21,0,0,0-34.79-8.45c-12.26-2.13-25-3.73-38.08-4.94s-26.31-2-39.61-2.47-26.59-.53-39.67-.23a298.42,298.42,0,0,0-38.24,3.12,281.28,281.28,0,0,0-35.09,7.41,226.29,226.29,0,0,0-30.28,10.7,135.05,135.05,0,0,0-12.74,6.4c-1.95,1.14-3.82,2.31-5.55,3.54-.86.61-1.68,1.24-2.49,1.91a17.48,17.48,0,0,0-2.13,2.08,9.6,9.6,0,0,0-2.31,4.95,10.2,10.2,0,0,0,.77,5.09,30.59,30.59,0,0,0,5.16,7.9c.65.76,1.29,1.48,1.9,2.16-.61-.2-1.23-.41-1.82-.63l-.81-.9a31.52,31.52,0,0,1-5.44-8.12,11.58,11.58,0,0,1-.92-5.63,10.94,10.94,0,0,1,2.52-5.61,17.87,17.87,0,0,1,2.26-2.26c.79-.68,1.66-1.35,2.54-2,1.78-1.26,3.68-2.46,5.65-3.63a135.87,135.87,0,0,1,12.83-6.54,229.62,229.62,0,0,1,30.43-10.95,282.27,282.27,0,0,1,35.25-7.66,301.51,301.51,0,0,1,38.45-3.36c13.13-.35,26.48-.26,39.81.17s26.65,1.23,39.74,2.42,25.91,2.77,38.25,4.91a224,224,0,0,1,35.1,8.63,90.12,90.12,0,0,1,15.39,6.86,42.15,42.15,0,0,1,6.64,4.64,41.07,41.07,0,0,1,5.38,5.68,24.73,24.73,0,0,1,3.74,6.6A14.55,14.55,0,0,1,449.13,156.13Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M467.76,151.57c-.38,11.09-13.87,18.68-27.28,23.5a163.08,163.08,0,0,1-26.71,6.84,31.91,31.91,0,0,0,3.75-3.28h0a25.28,25.28,0,0,0,1.82-2c.45-.53.89-1.08,1.31-1.66.28-.38.54-.76.81-1.16h0a31.92,31.92,0,0,0,5.1-12.49l0,0s15-1.66,12.79-13.6c-.94-5-8-11-22.9-16.4-20.6-7.53-56.22-14.11-111.56-16.07-59.68-2.1-101,5.58-123.6,13.91-13.53,5-20.34,10.22-20.34,13.71,0,9.33,12.53,11.13,12.54,11.13a30.19,30.19,0,0,0,4.26,16.46v0s-19.34.69-34.4-4.21c-.61-.2-1.23-.41-1.82-.63a42,42,0,0,1-4.1-1.73,29.33,29.33,0,0,1-3.69-2.12c-4.71-3.17-7.83-7.48-7.83-13.33,0-13.94,28.67-30.74,72.11-41.86,31.06-8,69.64-13,110.72-12,40.85,1,75.28,7.15,101.54,15.6C447.39,122.06,468.19,138.57,467.76,151.57Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-14)"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M457.1,162a16.22,16.22,0,0,1-4.26,6.3,20.22,20.22,0,0,1-5.93,3.75c-1,.39-1.93.78-2.88,1.18l-2.92,1c-1.92.6-3.75,1.18-5.56,1.59-3.59.89-6.92,1.46-9.93,1.9s-5.73.72-8.09.92a25.28,25.28,0,0,0,1.82-2c1.8-.26,3.78-.58,5.91-1a98.64,98.64,0,0,0,9.61-2.32c1.73-.48,3.5-1.08,5.31-1.71l2.71-1,2.84-1.26a14.71,14.71,0,0,0,8.17-8.43,14,14,0,0,0,.48-6.36,21.16,21.16,0,0,0-2.23-6.56,39.61,39.61,0,0,0-9.9-11.65,79.33,79.33,0,0,0-14.05-9.22c-2.55-1.37-5.25-2.61-8-3.8-1.35-.6-2.81-1.15-4.23-1.74s-2.84-1-4.28-1.55l-4.35-1.55-4.5-1.34-4.54-1.33-4.65-1.13a309.22,309.22,0,0,0-39.06-6.54c-13.45-1.43-27.19-2.37-40.95-2.92s-27.55-.77-41.14-1l-10.16-.14c-3.35,0-6.64,0-9.94.14-6.58.34-13.09.9-19.44,1.86a266.66,266.66,0,0,0-36.21,7.88,278.39,278.39,0,0,0-31.38,11c-4.71,2-9.23,4.07-13.34,6.24-1,.54-2.06,1-3.06,1.61l-2.94,1.71a56.8,56.8,0,0,0-5.32,3.49c-3.28,2.43-6.08,5.13-7.63,8.14a11.27,11.27,0,0,0-.79,8.9,24.41,24.41,0,0,0,3.65,6.82c.52.7,1,1.35,1.49,2a29.33,29.33,0,0,1-3.69-2.12c-.46-.62-.91-1.3-1.36-2a21,21,0,0,1-1.94-4,14,14,0,0,1-.79-5.06,13.6,13.6,0,0,1,1.43-5.46c1.76-3.52,4.77-6.46,8.16-9.08a56.32,56.32,0,0,1,5.5-3.74l2.92-1.73c1-.59,2.06-1.12,3.12-1.69,4.22-2.3,8.73-4.38,13.5-6.51a285.78,285.78,0,0,1,31.57-11.49,273.11,273.11,0,0,1,36.6-8.36c6.44-1,13-1.68,19.77-2.1,3.36-.14,6.77-.22,10.15-.25l10.16,0c13.6,0,27.43.19,41.27.67s27.68,1.28,41.26,2.78a311.55,311.55,0,0,1,39.64,6.65c1.59.39,3.17.77,4.73,1.17s3.12.9,4.66,1.36l4.61,1.37,4.49,1.6c1.49.55,2.95,1,4.46,1.62s2.83,1.15,4.24,1.79c2.87,1.28,5.63,2.59,8.29,4a80.26,80.26,0,0,1,14.7,9.89,43.38,43.38,0,0,1,10.63,13A23.41,23.41,0,0,1,458,154,17.49,17.49,0,0,1,457.1,162Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-15)"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M449.13,156.13a14.54,14.54,0,0,1-2.85,6.36A22,22,0,0,1,441.6,167a40.66,40.66,0,0,1-10.26,5.23,65.13,65.13,0,0,1-9.41,2.51l-1.27.23c.28-.38.54-.76.81-1.16h0l.25-.06a63,63,0,0,0,9.17-2.7,40.76,40.76,0,0,0,9.84-5.21,21.05,21.05,0,0,0,4.3-4.24,12.81,12.81,0,0,0,2.45-5.69,12.65,12.65,0,0,0-.76-6.45,22.79,22.79,0,0,0-3.56-6,35.15,35.15,0,0,0-2.44-2.76c-.42-.44-.86-.89-1.34-1.34s-.91-.83-1.39-1.26a42.32,42.32,0,0,0-6.38-4.39A88.38,88.38,0,0,0,416.54,127a241.21,241.21,0,0,0-34.79-8.45c-12.26-2.13-25-3.73-38.08-4.94s-26.31-2-39.61-2.47-26.59-.53-39.67-.23a298.42,298.42,0,0,0-38.24,3.12,281.28,281.28,0,0,0-35.09,7.41,226.29,226.29,0,0,0-30.28,10.7,135.05,135.05,0,0,0-12.74,6.4c-1.95,1.14-3.82,2.31-5.55,3.54-.86.61-1.68,1.24-2.49,1.91a17.48,17.48,0,0,0-2.13,2.08,9.6,9.6,0,0,0-2.31,4.95,10.2,10.2,0,0,0,.77,5.09,30.59,30.59,0,0,0,5.16,7.9c.65.76,1.29,1.48,1.9,2.16-.61-.2-1.23-.41-1.82-.63l-.81-.9a31.52,31.52,0,0,1-5.44-8.12,11.58,11.58,0,0,1-.92-5.63,10.94,10.94,0,0,1,2.52-5.61,17.87,17.87,0,0,1,2.26-2.26c.79-.68,1.66-1.35,2.54-2,1.78-1.26,3.68-2.46,5.65-3.63a135.87,135.87,0,0,1,12.83-6.54,229.62,229.62,0,0,1,30.43-10.95,282.27,282.27,0,0,1,35.25-7.66,301.51,301.51,0,0,1,38.45-3.36c13.13-.35,26.48-.26,39.81.17s26.65,1.23,39.74,2.42,25.91,2.77,38.25,4.91a224,224,0,0,1,35.1,8.63,90.12,90.12,0,0,1,15.39,6.86,42.15,42.15,0,0,1,6.64,4.64,41.07,41.07,0,0,1,5.38,5.68,24.73,24.73,0,0,1,3.74,6.6A14.55,14.55,0,0,1,449.13,156.13Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-16)"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M457.75,448.15c-.36-10.45-13.07-17.6-25.7-22.13a153,153,0,0,0-25.16-6.45c-.89-.35.49,4.26.88,4.8.27.36.44,8,1.08,11.78L419,439s14.16,1.56,12,12.82c-.89,4.72-7.52,10.31-21.57,15.45-19.41,7.09-53,13.29-105.1,15.13-56.22,2-95.15-5.25-116.43-13.1-12.75-4.7-19.16-9.63-19.16-12.92,0-8.78,9.77-10.13,9.78-10.13a52,52,0,0,1,.56-8.82l-.38-7.32a86.25,86.25,0,0,0-26.54,4.22l-1.72.59c-1.34.5-2.64,1-3.86,1.63a28.48,28.48,0,0,0-3.48,2c-4.43,3-7.37,7-7.37,12.56,0,13.13,27,29,67.93,39.43,29.26,7.49,65.6,12.25,104.3,11.32,38.48-.93,70.92-6.73,95.66-14.69C438.56,476,458.16,460.4,457.75,448.15Z",
  transform: "translate(-11.21 -20.8)",
  fill: "#2699fb"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M457.75,448.15c-.36-10.45-13.07-17.6-25.7-22.13a153,153,0,0,0-25.16-6.45c-.89-.35.49,4.26.88,4.8.27.36.44,8,1.08,11.78L419,439s14.16,1.56,12,12.82c-.89,4.72-7.52,10.31-21.57,15.45-19.41,7.09-53,13.29-105.1,15.13-56.22,2-95.15-5.25-116.43-13.1-12.75-4.7-19.16-9.63-19.16-12.92,0-8.78,9.77-10.13,9.78-10.13a52,52,0,0,1,.56-8.82l-.38-7.32a86.25,86.25,0,0,0-26.54,4.22l-1.72.59c-1.34.5-2.64,1-3.86,1.63a28.48,28.48,0,0,0-3.48,2c-4.43,3-7.37,7-7.37,12.56,0,13.13,27,29,67.93,39.43,29.26,7.49,65.6,12.25,104.3,11.32,38.48-.93,70.92-6.73,95.66-14.69C438.56,476,458.16,460.4,457.75,448.15Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-17)"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M447.71,438.36a15.36,15.36,0,0,0-4-5.94,19.44,19.44,0,0,0-5.59-3.54c-.92-.36-1.82-.73-2.71-1.1l-2.76-1c-1.81-.57-3.53-1.12-5.24-1.5a94,94,0,0,0-9.35-1.79c-2.85-.4-8.69-.71-10.91-.9.59.6.19,1.23.73,1.9,1.7.25,7.84.59,9.84,1,2.76.54,5.82,1.22,9.06,2.19,1.62.45,3.29,1,5,1.61l2.55,1,2.68,1.19a13.88,13.88,0,0,1,7.69,7.94,13,13,0,0,1,.45,6,19.51,19.51,0,0,1-2.1,6.18,37.29,37.29,0,0,1-9.32,11,74.62,74.62,0,0,1-13.24,8.69c-2.4,1.29-4.94,2.46-7.5,3.58-1.27.57-2.64,1.08-4,1.64s-2.68,1-4,1.46l-4.1,1.46-4.24,1.26-4.28,1.25L388,483a289.82,289.82,0,0,1-36.79,6.16c-12.68,1.35-25.62,2.24-38.58,2.75s-26,.73-38.76.9l-9.57.13c-3.15,0-6.25-.05-9.36-.13-6.21-.33-12.33-.86-18.31-1.75a251.5,251.5,0,0,1-34.12-7.43,261.71,261.71,0,0,1-29.56-10.39c-4.44-1.92-8.7-3.84-12.57-5.88-1-.51-1.94-1-2.88-1.52s-1.85-1.08-2.77-1.6a55.58,55.58,0,0,1-5-3.29c-3.09-2.29-5.73-4.83-7.19-7.67a10.63,10.63,0,0,1-.74-8.39,22.78,22.78,0,0,1,3.44-6.42c.48-.66,1-1.27,1.4-1.86a28.48,28.48,0,0,0-3.48,2c-.43.59-.86,1.22-1.28,1.91a19.7,19.7,0,0,0-1.82,3.8,12.38,12.38,0,0,0,.6,9.91c1.65,3.32,4.49,6.08,7.69,8.55a48.43,48.43,0,0,0,5.18,3.52l2.75,1.64c.94.55,1.94,1,2.93,1.59,4,2.16,8.23,4.12,12.72,6.13a269,269,0,0,0,29.74,10.82,257,257,0,0,0,34.48,7.88c6.07,1,12.3,1.58,18.63,2,3.16.13,6.38.2,9.56.23l9.57,0c12.81,0,25.84-.18,38.88-.63s26.08-1.2,38.87-2.61A294.65,294.65,0,0,0,389,487l4.46-1.1,4.39-1.28,4.34-1.29,4.23-1.51c1.4-.52,2.77-1,4.2-1.53s2.67-1.08,4-1.69c2.7-1.2,5.3-2.43,7.8-3.79a75.25,75.25,0,0,0,13.85-9.32,40.91,40.91,0,0,0,10-12.27,22.34,22.34,0,0,0,2.28-7.39A16.56,16.56,0,0,0,447.71,438.36Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-18)"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M440.2,443.85a13.76,13.76,0,0,0-2.68-6,21.13,21.13,0,0,0-4.41-4.22,37.94,37.94,0,0,0-9.67-4.92,62.09,62.09,0,0,0-8.86-2.37c-.42-.07-6.14-.64-6.53-.71.27.35-.11.84.15,1.22l5.95.38.24.05a60.79,60.79,0,0,1,8.63,2.54,38.64,38.64,0,0,1,9.28,4.92,19.86,19.86,0,0,1,4.05,4,12.29,12.29,0,0,1,2.31,5.36,12.09,12.09,0,0,1-.72,6.08,21.46,21.46,0,0,1-3.36,5.7,32.77,32.77,0,0,1-2.29,2.6c-.41.41-.82.83-1.27,1.26s-.85.78-1.31,1.19a39.37,39.37,0,0,1-6,4.13,83.52,83.52,0,0,1-14.21,6.2,226.35,226.35,0,0,1-32.77,8c-11.55,2-23.59,3.52-35.87,4.66s-24.78,1.88-37.31,2.32-25.05.5-37.38.22a282.43,282.43,0,0,1-36-2.94,263.47,263.47,0,0,1-33-7,212.15,212.15,0,0,1-28.53-10.07,129.24,129.24,0,0,1-12-6c-1.83-1.08-3.59-2.17-5.23-3.33-.8-.58-1.58-1.17-2.34-1.81a15.46,15.46,0,0,1-2-2,9.12,9.12,0,0,1-2.19-4.66,9.7,9.7,0,0,1,.73-4.79,28.77,28.77,0,0,1,4.86-7.44q.93-1.08,1.8-2l-1.72.59c-.24.27-.51.56-.76.85a29.86,29.86,0,0,0-5.13,7.65,10.88,10.88,0,0,0-.86,5.31,10.31,10.31,0,0,0,2.37,5.28,16.49,16.49,0,0,0,2.13,2.13c.74.64,1.56,1.27,2.4,1.89,1.67,1.19,3.46,2.32,5.31,3.43A132.32,132.32,0,0,0,168,467.65,216.33,216.33,0,0,0,196.68,478a266.3,266.3,0,0,0,33.21,7.21,283.25,283.25,0,0,0,36.22,3.17c12.37.33,24.94.24,37.5-.16S328.71,487,341,485.9s24.42-2.61,36-4.63a209.84,209.84,0,0,0,33.07-8.13,85.31,85.31,0,0,0,14.5-6.45,41.88,41.88,0,0,0,6.25-4.38A39.25,39.25,0,0,0,436,457a23.28,23.28,0,0,0,3.52-6.22A13.67,13.67,0,0,0,440.2,443.85Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-19)"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M132.62,476.53c4.36,19.59,1.65,41.81,11.35,58.8q-4.38-1.27-8.73-2.7C112.78,525.3,91,515.21,72.33,500.72a155.6,155.6,0,0,1-28.77-29.24,46.91,46.91,0,0,1,.59-4.8c7.43-42.21,53.84-33.47,82.6-21.48a140.17,140.17,0,0,1-6.51,29.1L110,466.59c-11.3,9-13.24,27.61-4,38.76A163.92,163.92,0,0,1,132.62,476.53Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-20)"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M530,479.62c3.88-15,1.8-31.27-8.52-42.53,5.86,24.57-5.31,52.27-26.57,65.91,9.45-11.1,2-28.21-7.25-39.5-4.66-5.71-10-11.75-13.72-18.27l.63-.24c26.91-10.41,51-32.47,79.78-30.84a36.39,36.39,0,0,1,7.14,1.09C555.16,438.94,545,461.1,530,479.62Z",
  transform: "translate(-11.21 -20.8)",
  fill: "url(#linear-gradient-21)"
});

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 558.67 529.38",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.47,415.24c-8.85,33.23-25.29,63.43-52,84.83-37.58,30.11-88.09,37.19-135.95,42.42-79.66,8.69-162.13,15-238.3-9.86C112.78,525.3,91,515.21,72.33,500.72a155.6,155.6,0,0,1-28.77-29.24A160.44,160.44,0,0,1,14,404.88,164.52,164.52,0,0,1,32.66,294.09c19.09-33.51,49.49-59.68,67.3-93.88,17.93-34.43,22-74.94,41.07-108.75,47.8-84.71,151.53-73,233.7-65.38,47.9,4.45,97.79,11.55,137.06,39.34,11.5,8.14,22.12,18.33,27.52,31.35s5.09,27.61,5.52,41.71c1.94,63.41,20.49,125.29,24.44,188.61C571.09,356.27,569.05,386.86,561.47,415.24Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, /*#__PURE__*/React.createElement("path", {
    d: "M271.79,400.52c-9.62-3-15.21,1.91-18.38,7.39,0,0-9.67-17.49-26.81-6.83,0,0,17.43-1.88,23.91,13.74h0a33.51,33.51,0,0,0-.93,4s9-13.21,22.21-7.76S282.7,438.3,282.7,438.3,290.49,406.36,271.79,400.52Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen"
    }
  }), _ref16, _ref17, _ref18, /*#__PURE__*/React.createElement("path", {
    d: "M423,503.1l-16.65,8.18L323.92,513H191.85s-9.07-5.89-15.48-20.47c0,0-8.18-8.27-3.51-17.85,4.48-9.2,12.18-.77,12.81,0-.55-.79-8.35-12.27-7.1-37.89.51-10.34,2.89-18.3,6.4-23-.36,11.07.48,29.48,7.76,42C203.25,473.88,215,475.05,215,475.05s-19.59-17.53-1.32-32.14,31.49,9.35,30.71,19.87c0,0,7.41-29.81,34.29-18.12V446s-14-4.29-19.38,10.52,9.83,28.05,24.64,26.48S303,469.53,303,469.53s6.24,23.63,19.48,20.91,10.9-21.58,10.9-21.58,17.95,20.8,40.15,9.89,18.71-49.48,0-53.76c0,0,9.4-5.68,18.23-1.76l.06,0c3.73,1.67,7.36,5.07,10.13,11.35,9.19,20.79-10.61,39.58-11.28,40.23.8-.2,27-7,25.42-33.32,3.49-.8,9,0,16.54,7.23C446.64,462.19,449.56,490,423,503.1Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), _ref19, _ref20, _ref21, /*#__PURE__*/React.createElement("path", {
    d: "M332.07,369.67c0,.32.08.64.1.94C332.14,370.41,332.1,370.1,332.07,369.67Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.1,349.41c-1.17-.39,0-23.29,26.88-19.44,0,0-8.57-12.15-22.21-4S276.1,349.41,276.1,349.41Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.66,331.49A19.29,19.29,0,0,1,328,342.2s7.53-8.53,17.4-2.71c0,0-1.07-5.8-13.39-3.2C332.05,336.29,325.77,329.93,318.66,331.49Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.64,390.86c4.73-10.05,22-15,22-15-12.63-5.65-21.27,5.31-21.27,5.31s.34-7.31-11-12.29-25.82,12.29-25.82,12.29,9.2-9.63,20.83-8c8.78,1.25,12.38,12.74,13.62,18.29a17,17,0,0,0-10.63,14.94h1.33s6.41-12.37,29-9.64C347.66,396.78,340.65,387.26,329.64,390.86Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.41,423.26a10.92,10.92,0,0,1,1.79-.9c-2.05,2.47-3.57,4-3.73,4.17,7.35-12-.76-32.8-5.7-39.57a8.79,8.79,0,0,1,7.55,1.6c9.57,7.32.7,32.82,0,34.67l0,.1A.39.39,0,0,0,391.41,423.26Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, /*#__PURE__*/React.createElement("path", {
    d: "M313.2,204.24c-4.67-.56-11.45-2.77-12.94-10.69,0,0-2.63,5.31-6.29,7.14-.8-9.75-1.34-15.82-1.34-15.82l8.11-9,13,14.34S314.12,191.48,313.2,204.24Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, /*#__PURE__*/React.createElement("path", {
    d: "M359.53,185.34s-5.23,11.87-26.13,14.33c-17.65,2.09-28.79-16.34-31.82-22.12-.56-1.06-.84-1.7-.84-1.7s-.38.63-1.12,1.62c-4.73,6.43-24.08,28.43-50.56.37,0,0-20.9,22.06-53,7.5-9.23-4.18-14.93-9.4-18.28-15a30.19,30.19,0,0,1-4.26-16.46c.12-8.31,3-15.79,4.61-20,.48,11.15,2.81,26.3,11.21,36.49,14.73,17.9,44.56,13.8,59.6,0,0,0,11.25,12.55,25.49,14.92S304.93,168,304.93,168s2.38,19.63,22.19,23.9S359.53,185.34,359.53,185.34Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), _ref48, _ref49, _ref50, _ref51, _ref52, /*#__PURE__*/React.createElement("path", {
    d: "M300.26,341c-4-7.39-11.12.59-12.3-2,0,0,0,0,0,0-.49-3.88-.14-7.87,2.71-9.74,6.52-4.25,9.6,5.76,9.6,5.76.4-5,.51-11.94.4-20.13C309.76,323.91,300.26,341,300.26,341Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.75,379.4c-.75-1.12-1.49-11.94,6.72-10.82s11.64,12.32,11.64,12.32a17.64,17.64,0,0,0-11.27-6.2C261.58,373.85,261.75,379.4,261.75,379.4Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.64,377.69h0c-2.62-2.41-6.26-4.32-10.65-3-9.36,2.84-4.85,14.41-4.85,14.41s-.41-11.2,7.8-11.95,12.32,6.6,12.32,6.6a24.12,24.12,0,0,0-2.45-3.72s.9-9.22,7.64-7.73,8.24,3.22,8.24,3.22S338.71,361,330.64,377.69Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.21,368.8c-10.89-3-22.67-.75-23.13.88,1.09-5.47,4.73-11.64,16.37-5.58A31.75,31.75,0,0,1,381.21,368.8Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.55,397.12c-.7,3.62-4.27,16.44-19.66,16.44a48.29,48.29,0,0,1-23.83-6.3c1.41.77,18.69,4.46,27.36,2.39C349.69,407.68,356.25,403.18,357.55,397.12Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,394.66a11.3,11.3,0,0,1-7.66,7.37s-7,5.36-24.57-5.83C358.51,396.44,378.9,402.67,390,394.66Z",
    transform: "translate(-11.21 -20.8)",
    fill: "#2699fb",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), _ref53, _ref54, _ref55, _ref56, _ref57, _ref58)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.5e266c71.svg";
export { ForwardRef as ReactComponent };